export class VehicleSearchParamsModel {
    pageSize: number;
    pageNumber: number;
    searchText: string;
    useThumbnails: boolean;
    vehicleSoldStateIn: string;
    dealership: string;
    orderByIn: string;
    orderByDesc: boolean;
    dateFrom: string = '1900-01-01';
    dateTo: string = '2999-12-31';
    enforce: boolean;
}
